import { useMediaQuery } from '@material-ui/core';
import { APP_THEME_DARK, APP_THEME_LIGHT } from './theme-constants';

const useSystemTheme = () => (useMediaQuery('(prefers-color-scheme: dark)')
  ? APP_THEME_DARK : APP_THEME_LIGHT);

export default useSystemTheme;
